import React from "react";
import { Box, chakra } from "@chakra-ui/react";
import { motion, isValidMotionProp } from "framer-motion";
const ChakraBox = chakra(motion.div, {
    shouldForwardProp: isValidMotionProp,
});
export function ProgressBar({ value, ...props }) {
    return (React.createElement(Box, { h: 2, bg: "gray.200", borderRadius: "md", overflow: "hidden", ...props },
        React.createElement(ChakraBox, { "aria-valuemin": "0", "aria-valuemax": "100", "aria-valuenow": value, role: "progressbar", w: "100%", h: "100%", bg: "forest", borderRadius: "md", initial: { x: "-100%" }, animate: { x: `-${100 - value}%` }, 
            // @ts-expect-error Chakra UI has `transition` prop, which overrides Framer Motion's
            transition: {
                damping: 10,
            } })));
}
